<template>
	<main>
		<div class="title">解决方案<i class="el-icon-arrow-left"></i>“冷却水精准管理+膜软化”标准业务
		</div>

		<div class="form">
			<section>
				<div class="section-title">
					<i class="point"></i>
					<h3>工艺参数调查</h3>
				</div>

				<a-table :columns="columns" :data-source="gongyiData.jiBenLengLiang" class="table" bordered :pagination="false" :row-key="(record, index) => index">
					<template slot="name" slot-scope="text">{{ text }}</template>
					<template slot="sheJiZhi" slot-scope="text, record">
						<a-input v-if="record.name !== '名义蒸发量（m³/h）'" v-model="record.sheJiZhi" style="width: 100px" @change="handleSheJiZhiChange(record)" />
						<template v-else>{{record.sheJiZhi}}</template>
					</template>
					<template slot="shiJiZhi" slot-scope="text, record">
						<a-input v-if="record.name !== '名义蒸发量（m³/h）'" v-model="record.shiJiZhi" style="width: 100px" @change="handleShiJiZhiChange(record)" />
						<template v-else>{{record.shiJiZhi}}</template>
					</template>
					<template v-slot:shiJiZhiDongJi="text, record">
						<a-input v-if="record.name !== '名义蒸发量（m³/h）'" v-model="record.shiJiZhiDongJi" style="width: 100px" @change="handleShiJiZhiDongJiChange(record)" />
						<template v-else>{{record.shiJiZhiDongJi}}</template>
					</template>
					<template slot="name" slot-scope="text">{{ text }}</template>
				</a-table>
				<h4>基本水平衡<span>（填写您认为最可靠的信息源，如果存在两个信息源，可以填写两次互证；保留您认为最可靠的那一版）</span></h4>
				<div class="row">
					<div class="col">
						<div class="checkbox-group">
							<h5>夏季</h5>
							<!-- <p v-for="item in gongyiData.shuiPingHeng">
            <a-checkbox :checked="item.isSelect">{{ item.item }}</a-checkbox>
          </p> -->

							<a-radio-group v-model="gongyiData.shuiPingHeng.value" @change="handleJiBenChange()">
								<a-radio :style="radioStyle" :key="index" v-for="(element,index) in gongyiData.shuiPingHeng.list"
									:value="element.value">{{ element.item }}</a-radio>
							</a-radio-group>
						</div>
						<a-form class="section-form" :model="gongyiData" name="basic" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }" autocomplete="off">
							<a-form-item label="实际排污量" name="shiJiPaiWuLiang">
								<a-input @change="handleJiSuanShuiPingHeng()" v-model="gongyiData.shiJiPaiWuLiang" :disabled="
                    gongyiData.shuiPingHeng.value == 'lv2' || gongyiData.shuiPingHeng.value == 'lv3' || gongyiData.shuiPingHeng.value == 'lv4'
                  ">
									<template #addonAfter>
										<p style="width: 55px">m³/h</p>
									</template>
								</a-input>
							</a-form-item>
							<a-form-item label="真实浓缩倍数" name="nongSuoBeiShu">
								<a-input @change="handleJiSuanShuiPingHeng()" v-model="gongyiData.nongSuoBeiShu" :disabled="
                    gongyiData.shuiPingHeng.value == 'lv1' || gongyiData.shuiPingHeng.value == 'lv3' || gongyiData.shuiPingHeng.value == 'lv4'
                  ">
									<template #addonAfter>
										<p style="width: 55px">倍</p>
									</template>
								</a-input>
							</a-form-item>
							<a-form-item label="实际补水量" name="shiJiBuShuiLiang">
								<a-input @change="handleJiSuanShuiPingHeng()" v-model="gongyiData.shiJiBuShuiLiang" :disabled="
                    gongyiData.shuiPingHeng.value == 'lv1' || gongyiData.shuiPingHeng.value == 'lv2' || gongyiData.shuiPingHeng.value == 'lv4'
                  ">
									<template #addonAfter>
										<p style="width: 55px">m³/h</p>
									</template>
								</a-input>
							</a-form-item>
						</a-form>
					</div>
					<div class="col">
						<div class="checkbox-group">
							<!-- <p v-for="item in gongyiData.shuiPingHeng">
            <a-checkbox :checked="item.isSelect">{{ item.item }}</a-checkbox>
          </p> -->
							<h5>冬季</h5>
							<a-radio-group v-model="gongyiData.shuiPingHengDongJi.value" @change="handleJiBenDongJiChange()">
								<a-radio :style="radioStyle" :key="index" v-for="(element,index) in gongyiData.shuiPingHengDongJi.list"
									:value="element.value">{{ element.item }}</a-radio>
							</a-radio-group>
						</div>
						<a-form class="section-form" :model="gongyiData" name="basic" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }" autocomplete="off">
							<a-form-item label="实际排污量" name="shiJiPaiWuLiangDongJi">
								<a-input @change="handleJiSuanShuiPingHengDongJi()" v-model="gongyiData.shiJiPaiWuLiangDongJi" :disabled="
                    gongyiData.shuiPingHengDongJi.value == 'lv2' ||
                    gongyiData.shuiPingHengDongJi.value == 'lv3' ||
                    gongyiData.shuiPingHengDongJi.value == 'lv4'
                  ">
									<template #addonAfter>
										<p style="width: 55px">m³/h</p>
									</template>
								</a-input>
							</a-form-item>
							<a-form-item label="真实浓缩倍数" name="nongSuoBeiShuDongJi">
								<a-input @change="handleJiSuanShuiPingHengDongJi()" v-model="gongyiData.nongSuoBeiShuDongJi" :disabled="
                    gongyiData.shuiPingHengDongJi.value == 'lv1' ||
                    gongyiData.shuiPingHengDongJi.value == 'lv3' ||
                    gongyiData.shuiPingHengDongJi.value == 'lv4'
                  ">
									<template #addonAfter>
										<p style="width: 55px">倍</p>
									</template>
								</a-input>
							</a-form-item>
							<a-form-item label="实际补水量" name="shiJiBuShuiLiangDongJi">
								<a-input @change="handleJiSuanShuiPingHengDongJi()" v-model="gongyiData.shiJiBuShuiLiangDongJi" :disabled="
                    gongyiData.shuiPingHengDongJi.value == 'lv1' ||
                    gongyiData.shuiPingHengDongJi.value == 'lv2' ||
                    gongyiData.shuiPingHengDongJi.value == 'lv4'
                  ">
									<template #addonAfter>
										<p style="width: 55px">m³/h</p>
									</template>
								</a-input>
							</a-form-item>
						</a-form>
					</div>
				</div>
				<h4>材质调查<span>（换热器和管道涉及敏感材质）</span></h4>
				<a-table :columns="columns2" :data-source="gongyiData.caiZhiDiaoCha" class="table" bordered :pagination="false" :row-key="(record, index) => index">
					<template v-slot:isSheJi="text, record">
						<a-checkbox v-model="record.isSheJi"></a-checkbox>
					</template>
					<template v-slot:isFuShi="text, record">
						<a-checkbox v-model="record.isFuShi"></a-checkbox>
					</template>
				</a-table>

				<a-form class="section-form2" :model="gongyiData" name="basic" :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }" autocomplete="off">
					<a-form-item label="所属行业" name="suoShuHangYe">
						<a-select v-model="gongyiData.suoShuHangYe" mode="tags" style="width: 100%" placeholder="请选择所属行业" :fieldNames="{ label: 'name', value: 'name' }"
							:options="industry"></a-select>
					</a-form-item>
					<a-form-item label="地理位置" name="diLiWeiZhi">
						<a-cascader v-model="gongyiData.diLiWeiZhi" :options="city" :fieldNames="{ label: 'name', value: 'name', children: 'children' }" placeholder="请选择地区" />
					</a-form-item>
				</a-form>
			</section>

			<!-- 补水 -->
			<section>
				<div class="section-title">
					<i class="point"></i>
					<h3>化学过程调查</h3>
				</div>
				<!-- 补水1 -->
				<div>
					<h4>补水1</h4>
					<div class="radio-group">
						<div class="label">类型：</div>
						<div class="extra">
							<a-radio-group v-model="bushui1.leiXing.value">
								<a-row :gutter="16">
									<a-col :key="index" v-for="(item, index) in bushui1.leiXing.list" :span="index % 2 == 0 ? 6 : 18">
										<a-radio :style="radioStyle" :value="item.item">
											{{ item.item }}
											<a-input v-if="item.item == '其他类型' && bushui1.leiXing.value == '其他类型'" v-model="bushui1.leiXingQiTa"
												style="width: 200px; margin-left: 10px" />
										</a-radio>
									</a-col>
								</a-row>
							</a-radio-group>
						</div>
					</div>
					<div class="radio-group">
						<div class="label">使用状态：</div>
						<div class="extra">
							<a-radio-group v-model="bushui1.shiYongZhuangTai.value">
								<a-row :gutter="16">
									<a-col :key="index" v-for="(item, index) in bushui1.shiYongZhuangTai.list" :span="index % 2 == 0 ? 18 : 6">
										<a-radio :style="radioStyle" :value="item.item">
											{{ item.item }}
										</a-radio>
									</a-col>
								</a-row>
							</a-radio-group>
						</div>
					</div>

					<a-table :columns="bushuiColumns" :data-source="bushui1.shuiZhiMiaoShu" class="table" bordered :pagination="false" style="margin-bottom: 20px"
						:row-key="(record, index) => index">
						<template v-slot:value="text, record">
							<a-input v-model="record.value" style="width: 100px" />
						</template>
						<template v-slot:remark="text, record">
							<a-input v-model="record.remark" style="width: 100%" />
						</template>
					</a-table>
				</div>

				<!-- 补水2 -->
				<div>
					<h4>补水2</h4>
					<div class="radio-group">
						<div class="label">类型：</div>
						<div class="extra">
							<a-radio-group v-model="bushui2.leiXing.value">
								<a-row :gutter="16">
									<a-col :key="index" v-for="(item, index) in bushui2.leiXing.list" :span="index % 2 == 0 ? 6 : 18">
										<a-radio :style="radioStyle" :value="item.item">
											{{ item.item }}
											<a-input v-if="item.item == '其他类型' && bushui2.leiXing.value == '其他类型'" v-model="bushui2.leiXingQiTa"
												style="width: 200px; margin-left: 10px" />
										</a-radio>
									</a-col>
								</a-row>
							</a-radio-group>
						</div>
					</div>
					<div class="radio-group">
						<div class="label">使用状态：</div>
						<div class="extra">
							<a-radio-group v-model="bushui2.shiYongZhuangTai.value">
								<a-row :gutter="16">
									<a-col :key="index" v-for="(item, index) in bushui2.shiYongZhuangTai.list" :span="index % 2 == 0 ? 18 : 6">
										<a-radio :style="radioStyle" :value="item.item">
											{{ item.item }}
										</a-radio>
									</a-col>
								</a-row>
							</a-radio-group>
						</div>
					</div>

					<a-table :columns="bushui2Columns" :data-source="bushui2.shuiZhiMiaoShu" class="table" bordered :pagination="false" style="margin-bottom: 20px"
						:row-key="(record, index) => index">
						<template v-slot:value="text, record">
							<a-input v-model="record.value" style="width: 100px" />
						</template>
						<template v-slot:remark="text, record">
							<a-input v-model="record.remark" style="width: 100%" />
						</template>
					</a-table>
				</div>

				<!-- 补水3 -->
				<div>
					<h4>补水3</h4>
					<div class="radio-group">
						<div class="label">类型：</div>
						<div class="extra">
							<a-radio-group v-model="bushui3.leiXing.value">
								<a-row :gutter="16">
									<a-col :key="index" v-for="(item, index) in bushui3.leiXing.list" :span="index % 2 == 0 ? 6 : 18">
										<a-radio :style="radioStyle" :value="item.item">
											{{ item.item }}
											<a-input v-if="item.item == '其他类型' && bushui3.leiXing.value == '其他类型'" v-model="bushui3.leiXingQiTa"
												style="width: 200px; margin-left: 10px" />
										</a-radio>
									</a-col>
								</a-row>
							</a-radio-group>
						</div>
					</div>
					<div class="radio-group">
						<div class="label">使用状态：</div>
						<div class="extra">
							<a-radio-group v-model="bushui3.shiYongZhuangTai.value">
								<a-row :gutter="16">
									<a-col :key="index" v-for="(item, index) in bushui3.shiYongZhuangTai.list" :span="index % 2 != 0 ? 6 : 18">
										<a-radio :style="radioStyle" :value="item.item">
											{{ item.item }}
										</a-radio>
									</a-col>
								</a-row>
							</a-radio-group>
						</div>
					</div>

					<a-table :columns="bushui3Columns" :data-source="bushui3.shuiZhiMiaoShu" class="table" bordered :pagination="false" style="margin-bottom: 20px"
						:row-key="(record, index) => index">
						<template v-slot:value="text, record">
							<a-input v-model="record.value" style="width: 100px" />
						</template>
						<template v-slot:remark="text, record">
							<a-input v-model="record.remark" style="width: 100%" />
						</template>
					</a-table>
				</div>

				<!-- 补水4 -->
				<div>
					<h4>补水4</h4>
					<div class="radio-group">
						<div class="label">类型：</div>
						<div class="extra">
							<a-radio-group v-model="bushui4.leiXing.value">
								<a-row :gutter="16">
									<a-col :key="index" v-for="(item, index) in bushui4.leiXing.list" :span="index % 2 == 0 ? 6 : 18">
										<a-radio :style="radioStyle" :value="item.item">
											{{ item.item }}
											<a-input v-if="item.item == '其他类型' && bushui4.leiXing.value == '其他类型'" v-model="bushui4.leiXingQiTa"
												style="width: 200px; margin-left: 10px" />
										</a-radio>
									</a-col>
								</a-row>
							</a-radio-group>
						</div>
					</div>
					<div class="radio-group">
						<div class="label">使用状态：</div>
						<div class="extra">
							<a-radio-group v-model="bushui4.shiYongZhuangTai.value">
								<a-row :gutter="16">
									<a-col :key="index" v-for="(item, index) in bushui4.shiYongZhuangTai.list" :span="index % 2 != 0 ? 6 : 18">
										<a-radio :style="radioStyle" :value="item.item">
											{{ item.item }}
										</a-radio>
									</a-col>
								</a-row>
							</a-radio-group>
						</div>
					</div>

					<a-table :columns="bushui4Columns" :data-source="bushui4.shuiZhiMiaoShu" class="table" bordered :pagination="false" style="margin-bottom: 20px"
						:row-key="(record, index) => index">
						<template v-slot:value="text, record">
							<a-input v-model="record.value" style="width: 100px" />
						</template>
						<template v-slot:remark="text, record">
							<a-input v-model="record.remark" style="width: 100%" />
						</template>
					</a-table>
				</div>

				<div>
					<h4>循环水</h4>
					<a-table :columns="xunhuanshuiColumns" :data-source="xunhuanshui" class="table" bordered :pagination="false" style="margin-bottom: 20px"
						:row-key="(record, index) => index">
						<template v-slot:value="text, record">
							<a-input v-model="record.value" style="width: 100px" />
						</template>
						<template v-slot:remark="text, record">
							<a-input v-model="record.remark" style="width: 100%" />
						</template>
					</a-table>
				</div>
			</section>

			<section>
				<div class="section-title">
					<i class="point"></i>
					<h3>问题描述</h3>
				</div>
				<a-form class="section-form3" :model="formState" name="basic" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }" autocomplete="off">
					<a-form-item label="我对目前的冷却水系统有如下不满意" name="other">
						<a-input type="textarea" :rows="10" style="resize: none" v-model="formState.other"></a-input>
					</a-form-item>
				</a-form>
			</section>

			<a-button class="btn_submit" size="large" type="primary" @click="handleSubmit">提交</a-button>
		</div>
	</main>
</template>
<script>
	import BaseSearch from '@/components/layout/base/base-search-front';
	//import { LeftOutlined, SendOutlined, CheckOutlined } from "@ant-design/icons-vue";

	// 工艺参数调查数据
	import parameters from "../../assets/json/process_parameters.json";
	// 行业
	import industry from "../../assets/json/industry.json";
	// 省市
	import city from "../../assets/json/pc-code.json";
	// 补水数据
	import chemical from "../../assets/json/process_chemical.json";
	// 循环水数据
	import cycleWater from "../../assets/json/process_chemical_cycle_water.json";
	import axios from '../../../config/http.js'



	export default {
		extends: BaseSearch,
		props: ['device'],
		data() {
			return {
				autoQuery: false,
				city: city,
				industry: null,
				radioStyle: {
					display: "flex",
					padding: "10px 0 10px 0",
				},
				formState: {
					other: "",
				},
				columns: [{
						title: "基本冷量",
						dataIndex: "name",
						key: "name"
					},
					{
						title: "设计值",
						dataIndex: "sheJiZhi",
						key: "sheJiZhi",
						scopedSlots: {
							customRender: 'sheJiZhi'
						},
					},
					{
						title: "夏季实际运行值",
						dataIndex: "shiJiZhi",
						key: "shiJiZhi",
						scopedSlots: {
							customRender: 'shiJiZhi'
						},
					},
					{
						title: "冬季实际运行值",
						dataIndex: "shiJiZhiDongJi",
						key: "shiJiZhiDongJi",
						scopedSlots: {
							customRender: 'shiJiZhiDongJi'
						},
					},
				],
				gongyiData: parameters,
				bushui1: JSON.parse(JSON.stringify(chemical)),
				bushuiColumns: [{
						title: "补水1水质描述",
						children: [{
								title: "",
								dataIndex: "name",
								key: "name",
							},
							{
								title: "",
								dataIndex: "unit",
								key: "unit",
							},
							{
								title: "",
								dataIndex: "value",
								key: "value",
								scopedSlots: {
									customRender: 'value'
								},
							},
						],
					},
					{
						title: "备注",
						dataIndex: "remark",
						key: "remark",
						scopedSlots: {
							customRender: 'remark'
						},
					},
				],
				bushui2: JSON.parse(JSON.stringify(chemical)),
				bushui2Columns: [{
						title: "补水2水质描述",
						children: [{
								title: "",
								dataIndex: "name",
								key: "name",
							},
							{
								title: "",
								dataIndex: "unit",
								key: "unit",
							},
							{
								title: "",
								dataIndex: "value",
								key: "value",
								scopedSlots: {
									customRender: 'value'
								},
							},
						],
					},
					{
						title: "备注",
						dataIndex: "remark",
						key: "remark",
						scopedSlots: {
							customRender: 'remark'
						},
					},
				],
				bushui3: JSON.parse(JSON.stringify(chemical)),
				bushui3Columns: [{
						title: "补水3水质描述",
						children: [{
								title: "",
								dataIndex: "name",
								key: "name",
							},
							{
								title: "",
								dataIndex: "unit",
								key: "unit",
							},
							{
								title: "",
								dataIndex: "value",
								key: "value",
								scopedSlots: {
									customRender: 'value'
								},
							},
						],
					},
					{
						title: "备注",
						dataIndex: "remark",
						key: "remark",
						scopedSlots: {
							customRender: 'remark'
						},
					},
				],
				bushui4: JSON.parse(JSON.stringify(chemical)),
				bushui4Columns: [{
						title: "补水4水质描述",
						children: [{
								title: "",
								dataIndex: "name",
								key: "name",
							},
							{
								title: "",
								dataIndex: "unit",
								key: "unit",
							},
							{
								title: "",
								dataIndex: "value",
								key: "value",
								scopedSlots: {
									customRender: 'value'
								},
							},
						],
					},
					{
						title: "备注",
						dataIndex: "remark",
						key: "remark",
						scopedSlots: {
							customRender: 'remark'
						},
					},
				],
				xunhuanshui: cycleWater,
				xunhuanshuiColumns: [{
						title: "循环水",
						children: [{
								title: "",
								dataIndex: "name",
								key: "name",
							},
							{
								title: "",
								dataIndex: "unit",
								key: "unit",
							},
							{
								title: "",
								dataIndex: "value",
								key: "value",
								scopedSlots: {
									customRender: 'value'
								},
							},
						],
					},
					{
						title: "备注",
						dataIndex: "remark",
						key: "remark",
						scopedSlots: {
							customRender: 'remark'
						},
					},
				],
				columns2: [{
						title: "",
						dataIndex: "name",
						key: "name",
					},
					{
						title: "是否涉及",
						dataIndex: "isSheJi",
						key: "isSheJi",
						scopedSlots: {
							customRender: 'isSheJi'
						},
					},
					{
						title: "是否发生腐蚀",
						dataIndex: "isFuShi",
						key: "isFuShi",
						scopedSlots: {
							customRender: 'isFuShi'
						},
					},
				]

			}
		},
		filters: {},
		created() {
			this.gongyiData = Object.assign({}, parameters);
		},
		methods: {
			handleSheJiZhiChange() {
				const A = this.gongyiData.jiBenLengLiang[0].sheJiZhi;
				const B = this.gongyiData.jiBenLengLiang[2].sheJiZhi;

				if (A && B) {
					const num = A * B * 0.0016;
					console.log("num", num);
					this.gongyiData.jiBenLengLiang[3].sheJiZhi = num.toFixed(2);
				}
			},
			handleShiJiZhiChange() {
				const A = this.gongyiData.jiBenLengLiang[0].shiJiZhi;
				const B = this.gongyiData.jiBenLengLiang[2].shiJiZhi;

				if (A && B) {
					const num = A * B * 0.0016;
					console.log("num", num);
					//this.gongyiData.jiBenLengLiang[3].shiJiZhi = num.toFixed(2);
					this.$set(this.gongyiData.jiBenLengLiang[3], 'shiJiZhi', num.toFixed(2));
				}
			},
			handleShiJiZhiDongJiChange() {
				const A = this.gongyiData.jiBenLengLiang[0].shiJiZhiDongJi;
				const B = this.gongyiData.jiBenLengLiang[2].shiJiZhiDongJi;

				if (A && B) {
					const num = A * B * 0.001;
					console.log("num", num);
					this.gongyiData.jiBenLengLiang[3].shiJiZhiDongJi = num.toFixed(2);
				}
			},
			handleJiBenChange() {
				this.gongyiData.shiJiPaiWuLiang = "";
				this.gongyiData.nongSuoBeiShu = "";
				this.gongyiData.shiJiBuShuiLiang = "";
			},
			handleJiBenDongJiChange() {
				this.gongyiData.shiJiPaiWuLiangDongJi = "";
				this.gongyiData.nongSuoBeiShuDongJi = "";
				this.gongyiData.shiJiBuShuiLiangDongJi = "";
			},
			handleJiSuanShuiPingHeng() {
				const E = Number(this.gongyiData.jiBenLengLiang[3].shiJiZhi);
				const C = Number(this.gongyiData.shiJiPaiWuLiang);
				const D = Number(this.gongyiData.nongSuoBeiShu);
				const F = Number(this.gongyiData.shiJiBuShuiLiang);

				console.log("E:", E, "  |C:", C, "  |D:", D, "  |F:", F);

				switch (this.gongyiData.shuiPingHeng.value) {
					case "lv1":
						console.log("E+C", E + C);
						this.gongyiData.nongSuoBeiShu = ((E + C) / C).toFixed(2);
						this.gongyiData.shiJiBuShuiLiang = (E + C).toFixed(2);
						break;
					case "lv2":
						this.gongyiData.shiJiPaiWuLiang = (E / (D - 1)).toFixed(2);
						this.gongyiData.shiJiBuShuiLiang = (E / (D - 1) + E).toFixed(2);
						break;
					case "lv3":
						this.gongyiData.shiJiPaiWuLiang = (F - E).toFixed(2);
						this.gongyiData.nongSuoBeiShu = (F / (F - E)).toFixed(2);
						break;
					case "lv4":
						break;
					default:
						return;
				}

			},
			handleJiSuanShuiPingHengDongJi() {

				const E = Number(this.gongyiData.jiBenLengLiang[3].shiJiZhiDongJi);
				const C = Number(this.gongyiData.shiJiPaiWuLiangDongJi);
				const D = Number(this.gongyiData.nongSuoBeiShuDongJi);
				const F = Number(this.gongyiData.shiJiBuShuiLiangDongJi);

				console.log("E:", E, "  |C:", C, "  |D:", D, "  |F:", F);

				switch (this.gongyiData.shuiPingHengDongJi.value) {
					case "lv1":
						console.log("E+C", E + C);
						this.gongyiData.nongSuoBeiShuDongJi = ((E + C) / C).toFixed(2);
						this.gongyiData.shiJiBuShuiLiangDongJi = (E + C).toFixed(2);
						break;
					case "lv2":
						this.gongyiData.shiJiPaiWuLiangDongJi = (E / (D - 1)).toFixed(2);
						this.gongyiData.shiJiBuShuiLiangDongJi = (E / (D - 1) + E).toFixed(2);
						break;
					case "lv3":
						this.gongyiData.shiJiPaiWuLiangDongJi = (F - E).toFixed(2);
						this.gongyiData.nongSuoBeiShuDongJi = (F / (F - E)).toFixed(2);
						break;
					case "lv4":
						break;
					default:
						return;
				}
			},
			init() {
				this.gongyiData = JSON.parse(JSON.stringify(parameters));
				this.bushui1 = JSON.parse(JSON.stringify(chemical));
				this.bushui2 = JSON.parse(JSON.stringify(chemical));
				this.bushui3 = JSON.parse(JSON.stringify(chemical));
				this.bushui4 = JSON.parse(JSON.stringify(chemical));
				this.xunhuanshui = JSON.parse(JSON.stringify(cycleWater));
			},
			handleSubmit() {
				console.log("gongyiData", this.gongyiData);
				const obj = {
					schemeType: 1,
					processParameters: JSON.stringify(this.gongyiData),
					processChemicalOne: JSON.stringify(this.bushui1),
					processChemicalTwo: JSON.stringify(this.bushui2),
					processChemicalThree: JSON.stringify(this.bushui3),
					processChemicalFour: JSON.stringify(this.bushui4),
					processChemicalCycleWater: JSON.stringify(this.xunhuanshui),
					other: this.formState.other,
					deviceId: this.device.id
				};

				axios({
					method: 'POST',
					url: '/device/scheme/create',
					data: obj
				}).then((res) => {
					if (res.data.errorCode == '0000') {
						this.$notify({
							title: '系统提示',
							message: '提交成功',
							type: 'success'
						});
					}
				})
			},
			initIndustry(list) {
				if (list) {
					var that = this
					list.forEach(item => {
						item.label = item.name
						item.value = item.name
						that.initIndustry(item.children)
					})
				}
			},
			getChemicalsLog() {
				axios({
					method: 'POST',
					url: '/device/scheme/query',
					data: {
						deviceId: this.device.id,
						currentPage: 1,
						pageSize: 1
					}
				}).then((res) => {
					if (res.data.data) {
						var data = res.data.data[0]
						this.gongyiData = JSON.parse(data.processParameters)
						this.bushui1 = JSON.parse(data.processChemicalOne)
						this.bushui2 = JSON.parse(data.processChemicalTwo)
						this.bushui3 = JSON.parse(data.processChemicalThree)
						this.bushui4 = JSON.parse(data.processChemicalFour)
						this.xunhuanshui = JSON.parse(data.processChemicalCycleWater)
						this.formState.other = data.other
					}
				})
			}
		},
		mounted: function() {
			this.init()
			this.initIndustry(industry)
			this.industry = industry
			this.getChemicalsLog()
		}
	}
</script>

<style scoped>
	main {
		background-color: #fff;
		overflow: hidden;
		padding-bottom: 60px;
	}

	.title {
		width: 100%;
		max-width: 1200px;
		margin: 0 auto;
		margin-top: 60px;

		font-weight: bold;
		font-size: 24px;
		color: #333333;
		line-height: 31px;
	}

	.form {
		width: 100%;
		max-width: 1200px;
		margin: 0 auto;
		margin-top: 40px;
	}

	section {
		.section-title {
			background: #f7f8fa;
			padding: 13px 20px;
			display: flex;
			align-items: center;

			.point {
				width: 4px;
				height: 16px;
				background: #2a76ff;
				border-radius: 4px;
				margin-right: 20px;
			}

			h3 {
				font-weight: bold;
				font-size: 16px;
				color: #333333;
				line-height: 21px;
			}
		}

		.table {
			margin-top: 20px;
			margin-left: 80px;
			max-width: 70%;
		}

		:deep .table-striped td {
			background-color: #fafafa;
		}

		h4 {
			font-weight: bold;
			font-size: 16px;
			color: #333333;
			line-height: 21px;
			margin-top: 40px;
			padding-left: 40px;

			span {
				font-size: 14px;
				color: #666666;
				line-height: 19px;
			}
		}

		.row {
			display: flex;

			.col {
				flex: 1;
				position: relative;

				&:first-child:after {
					content: "";
					display: block;
					width: 1px;
					background-color: #f0f0f0;
					position: absolute;
					right: 0;
					top: 30px;
					bottom: 0;
				}

				h5 {
					font-weight: bold;
					font-size: 14px;
					color: #333333;
					line-height: 21px;
				}
			}
		}

		.checkbox-group {
			margin-top: 10px;
			padding: 10px 10px 20px 80px;

			p {
				margin: 10px 0 0;

				font-size: 14px;
				color: #333333;
				line-height: 19px;
			}
		}

		.section-form {
			margin-top: 10px;
			padding-left: 40px;
		}

		.section-form2 {
			margin-top: 20px;
		}

		.section-form3 {
			margin-top: 40px;
		}

		.radio-group {
			margin-top: 20px;
			display: flex;

			.label {
				width: 100px;
				text-align: right;
				padding-right: 10px;

				font-size: 14px;
				color: #333333;
				line-height: 19px;
				padding-top: 8px;
			}

			.extra {
				flex: 1;
			}
		}
	}

	:deep .ant-radio-group {
		width: 100%;
	}

	/deep/ p {
		margin-bottom: 0px;
	}

	.btn_submit {
		margin-top: 20px;
		float: right;
		position: fixed;
		bottom: 0px;
		right:20px;
		transform: translate(-50%, -50%);
	}
</style>


// WEBPACK FOOTER //
// src/view/system/standard.vue